<template>
  <div>
    <div class="order-block" v-if="isOrderBlockView">
      <div class="block">
        <div class="block-title center">
          <h2>Детали заказа</h2>
        </div>
      </div>
      <IncomeReturnMethod v-if="isIncomeReturnView" />
      <div v-if="!isCrmCourierChosen">
        <PaymentMethod v-if="isShowPaymentMethods" />
        <ChoosePaymentCard
          v-if="!isAnonimousForm && order.paymentMethod === 5 && user.cards?.length"
          :key="order.paymentMethod"
        />
        <PromoCode />
      </div>
    </div>
    <div v-if="!isYandexForm && !isAnonimousForm" class="order-block">
      <ExtraDetails />
    </div>
    <div v-if="!isYandexForm && !isAnonimousForm && !isCrmCourierChosen" class="order-block">
      <ExtraServices />
    </div>
    <div v-if="!isYandexForm && isAnonimousForm && !isCrmCourierChosen" class="order-block">
      <ExtraServicesAnonimous />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import { GENERAL_STORE } from '@apps/order-form/src/store'
import ExtraServicesAnonimous from './OrderDetails/ExtraServicesAnonimous.vue'
import IncomeReturnMethod from './OrderDetails/IncomeReturnMethod.vue'
import PaymentMethod from './OrderDetails/PaymentMethod.vue'
import PromoCode from './OrderDetails/PromoCode.vue'
import ExtraDetails from './OrderDetails/ExtraDetails.vue'
import ExtraServices from './OrderDetails/ExtraServices.vue'
import ChoosePaymentCard from './OrderDetails/ChoosePaymentCard.vue'

export default {
  name: 'orderDetails',

  data: () => ({ showRedBanner: true }),

  components: {
    ExtraServicesAnonimous,
    IncomeReturnMethod,
    PaymentMethod,
    PromoCode,
    ExtraDetails,
    ExtraServices,
    ChoosePaymentCard,
  },

  computed: {
    ...mapState(GENERAL_STORE, ['order', 'form', 'isShowPaymentMethods', 'user']),
    ...mapGetters(GENERAL_STORE, [
      'isCashOnDelivery',
      'isDeliveryExtraPay',
      'isBuyout',
      'isYandexForm',
      'isAnonimousForm',
      'isCrmCourierChosen',
    ]),

    isIncomeReturnView() {
      return (this.isCashOnDelivery || this.isDeliveryExtraPay) && !this.isBuyout
    },
    isOrderBlockView() {
      const conditionsList = [!this.isCrmCourierChosen, this.isIncomeReturnView]

      return conditionsList.includes(true)
    },
  },
}
</script>
